import { getSharedStyleSheet } from './sharedStyleSheet.js';

class ProgressBarCircular extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['image-url', 'progress', "use-color-image"];
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this[attrName] = newValue;
        this.render();
    }

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: "open"});

            // Make sure element obeys parent sizing
            this.shadowRoot.host.style.display = 'inline-block';

            // Share a single parsed stylesheet across all shadow roots
            getSharedStyleSheet().then(sheet => {
                this.shadowRoot.adoptedStyleSheets = [sheet];
            });

            const style = getComputedStyle(document.documentElement);

            this._wrapper = document.createElement('div');
            this._wrapper.className = 'progress-bar-circular';
            this._wrapper.style.position = 'relative';
            this._wrapper.style.margin = '0';
            this._wrapper.style.padding = '0';
            this.shadowRoot.appendChild(this._wrapper);

            if (this.getAttribute('width')) this._wrapper.style.width = this.getAttribute('width') + 'px';
            if (this.getAttribute('height')) this._wrapper.style.height = this.getAttribute('height') + 'px';

            this._img = document.createElement('div');
            this._img.style.position = 'absolute';
            this._img.style.left = '0';
            this._img.style.right = '0';
            this._img.style.top = '0';
            this._img.style.bottom = '0';
            this._img.style.width = '100%';
            this._img.style.height = '100%';
            this._wrapper.appendChild(this._img);

            this._canvas = document.createElement('canvas');
            this._canvas.width = (this.getAttribute('width') ?? 0) * window.devicePixelRatio;
            this._canvas.height = (this.getAttribute('height') ?? 0) * window.devicePixelRatio;
            this._canvas.style.position = 'absolute';
            this._canvas.style.left = '0';
            this._canvas.style.right = '0';
            this._canvas.style.top = '0';
            this._canvas.style.bottom = '0';
            this._canvas.style.width = '100%';
            this._canvas.style.height = '100%';
            this._wrapper.appendChild(this._canvas);
        }

        this.render();
    }

    disconnectedCallback() {
    }

    render() {
        if (!this.shadowRoot) return;

        let percent = this.getAttribute('progress') ?? 0;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;

        const style = getComputedStyle(document.documentElement);

        const ctx = this._canvas.getContext('2d');
        ctx.lineCap = 'round';

        ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);

        const posX = this._canvas.width / 2, posY = this._canvas.height / 2;

        ctx.beginPath();
        ctx.arc(posX, posY, this._canvas.width / 2.5, (Math.PI / 180) * 270, (Math.PI / 180) * (270 + 360));
        ctx.strokeStyle = style.getPropertyValue('--page-text-color');
        ctx.lineWidth = 2 * window.devicePixelRatio;
        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle = style.getPropertyValue('--accent-color');
        ctx.lineWidth = 3 * window.devicePixelRatio;
        ctx.arc(posX, posY, this._canvas.width / 2.5, (Math.PI / 180) * 270, (Math.PI / 180) * (270 + (360 / 100) * percent));
        ctx.stroke();

        const imageURL = this.getAttribute('image-url');

        if (imageURL && this.getAttribute('use-color-image')) {
            this._img.style.background = "url('" + this.getAttribute('image-url') + "') no-repeat center/51%";
        } else {
            if (imageURL) {
                if (typeof this._img.style.mask !== 'undefined') this._img.style.mask = "url('" + this.getAttribute('image-url') + "') no-repeat center/51%";
                if (typeof this._img.style.webkitMask !== 'undefined') this._img.style.webkitMask = "url('" + this.getAttribute('image-url') + "') no-repeat center/51%";
                this._img.style.backgroundColor = style.getPropertyValue('--page-text-color');
            } else {
                if (typeof this._img.style.mask !== 'undefined') this._img.style.mask = '';
                if (typeof this._img.style.webkitMask !== 'undefined') this._img.style.webkitMask = '';
                this._img.style.backgroundColor = 'transparent';
            }
        }
    }
}

customElements.define('progress-bar-circular', ProgressBarCircular);